<template>
  <div>
    <div ref="form">
      <!-- Row Loop -->
      <b-row
        v-for="(transporte, index) in Autotransportes"
        :id="index"
        :key="index"
        ref="row"
      >
        <!-- Item Name -->
        <b-col cols="10">
          <Autotransporte :transporte="transporte" :index="index" />
        </b-col>

        <!-- Remove Button -->
        <b-col v-if="Autotransportes.length > 1" cols="2">
          <b-button
            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
            variant="outline-danger"
            class="mt-0 mt-md-2"
            @click="removeItem(index)"
          >
            <feather-icon icon="XIcon" class="mr-25" />
            <span>Borrar</span>
          </b-button>
        </b-col>
        <b-col cols="12">
          <hr />
        </b-col>
      </b-row>

      <b-button
        v-if="Autotransportes.length < 1"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="addItem"
      >
        <feather-icon icon="PlusIcon" class="mr-25" />
        <span>Agregar transporte</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BButton } from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import { mapActions } from 'vuex'
import { mapMultiRowFields } from 'vuex-map-fields'
import Autotransporte from '@/views/CartaPorte/Autotransporte'

export default {
  components: {
    Autotransporte,
    BRow,
    BCol,
    BButton,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      nextRowId: 0,
    }
  },
  computed: {
    ...mapMultiRowFields('CartaPorte', {
      Autotransportes:
        'objJson.complemento.CartaPorte.Mercancias.Autotransporte',
    }),
  },
  mounted() {
    this.initTrHeight()
    this.nextRowId = this.Autotransportes.length
    this.addItem()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    ...mapActions('CartaPorte', ['addAutotransporte', 'deleteAutotransporte']),
    addItem() {
      this.addAutotransporte({
        '@PermSCT': '',
        '@NumPermisoSCT': '',
        IdentificacionVehicular: {
          '@ConfigVehicular': '',
          '@PesoBrutoVehicular': '',
          '@PlacaVM': '',
          '@AnioModeloVM': '',
        },
        Seguros: {
          '@AseguraRespCivil': '',
          '@PolizaRespCivil': '',
          '@AseguraMedAmbiente': '',
          '@PolizaMedAmbiente': '',
          '@AseguraCarga': '',
          '@PolizaCarga': '',
          '@PrimaSeguro': '',
        },
        Remolques: {
          Remolque: [],
        },
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.deleteAutotransporte(index)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>

<style lang="scss">
@import 'src/@core/scss/vue/libs/vue-select.scss';
</style>
